export default __webpack_public_path__ + "static/media/no_result_tractor.9ab802fd.png";